/* Breezary homepage v5: hero carousel, browse tabs, review scroller */
(function () {
  'use strict';
  var root = document.querySelector('[data-bz5]');
  if (!root || root.__bz5) return;
  root.__bz5 = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };

  /* hero: fades between slides, pauses while hovered / focused / hidden */
  var hero = root.querySelector('[data-bz5-hero]');
  if (hero) {
    var slides = hero.querySelectorAll('.bz5-slide'), dots = hero.querySelectorAll('.bz5-dot'), cur = 0, hold = false;
    var go = function (n) {
      n = (n + slides.length) % slides.length;
      slides[cur].classList.remove('is-active'); slides[cur].setAttribute('aria-hidden', 'true');
      if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].setAttribute('aria-current', 'false'); }
      cur = n;
      slides[cur].classList.add('is-active'); slides[cur].removeAttribute('aria-hidden');
      if (dots[cur]) { dots[cur].classList.add('is-active'); dots[cur].setAttribute('aria-current', 'true'); }
    };
    each(dots, function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var prev = hero.querySelector('[data-bz5-prev]'), next = hero.querySelector('[data-bz5-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    hero.addEventListener('mouseenter', function () { hold = true; });
    hero.addEventListener('mouseleave', function () { hold = false; });
    hero.addEventListener('focusin', function () { hold = true; });
    hero.addEventListener('focusout', function () { hold = false; });
    if (slides.length > 1) setInterval(function () { if (!hold && !reduce.matches && !document.hidden) go(cur + 1); }, 6500);
  }

  /* browse tabs (WAI-ARIA tabs, arrow keys move between tabs) */
  each(root.querySelectorAll('[data-bz5-tabs]'), function (box) {
    var tabs = box.querySelectorAll('[role=tab]');
    var select = function (t, focus) {
      each(tabs, function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.setAttribute('tabindex', on ? '0' : '-1');
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    };
    each(tabs, function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  });

  /* review scroller: arrow buttons move one card, and switch off at either end */
  each(root.querySelectorAll('[data-bz5-scroller]'), function (wrap) {
    var track = wrap.querySelector('[data-bz5-track]');
    var prev = wrap.querySelector('[data-bz5-prev]'), next = wrap.querySelector('[data-bz5-next]');
    if (!track) return;
    var step = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    var sync = function () {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();



/* Breezary collection + cart previews: filter drawer, filter tags, sort, buying-guide accordion, cart maths */
(function () {
  'use strict';
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };
  var money = function (n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- sticky bits (filter bar, cart summary, guide column) stay below the header while it is shown ---------- */
  var headerBar = document.querySelector('[data-bzh-sticky]');
  if (headerBar && 'MutationObserver' in window) {
    var place = function () {
      var shown = headerBar.classList.contains('is-fixed') && !headerBar.classList.contains('is-hidden');
      document.documentElement.style.setProperty('--bz5-stick', shown ? headerBar.offsetHeight + 'px' : '0px');
    };
    new MutationObserver(place).observe(headerBar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', place);
    place();
  }

  /* ---------- collection: filter drawer (tablets / phones) ---------- */
  var panel = document.querySelector('[data-bz5-filters]');
  var scrim = document.querySelector('[data-bz5-scrim]');
  var opener = document.querySelector('[data-bz5-filters-open]');
  if (panel && opener) {
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      panel.classList.add('is-open'); panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      if (scrim) scrim.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = panel.querySelector('.bz5-filters__close'); if (first) first.focus();
    };
    var close = function () {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); panel.removeAttribute('role'); panel.removeAttribute('aria-modal');
      if (scrim) scrim.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    opener.addEventListener('click', open);
    each(panel.querySelectorAll('[data-bz5-filters-close]'), function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {  // keep focus inside the drawer
        var f = Array.prototype.filter.call(panel.querySelectorAll('button, input, select, summary, a[href]'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.matchMedia('(min-width: 1200px)').addEventListener('change', function (m) { if (m.matches) close(); });
  }

  /* ---------- collection: "show more" values ---------- */
  each(document.querySelectorAll('[data-bz5-more]'), function (b) {
    var list = document.getElementById(b.getAttribute('aria-controls'));
    var n = b.getAttribute('data-n');
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-expanded') !== 'true';
      each(list.querySelectorAll('[data-more]'), function (li) { li.hidden = !on; });
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      b.textContent = on ? 'Show less' : 'Show ' + n + ' more';
    });
  });

  /* ---------- collection: selected filters -> tags; "In stock" and sort really change this page ---------- */
  var grid = document.querySelector('[data-bz5-grid]');
  if (grid) {
    var tagsBox = document.querySelector('[data-bz5-active]'), tags = document.querySelector('[data-bz5-tags]');
    var note = document.querySelector('[data-bz5-note]'), fcount = document.querySelector('[data-bz5-fcount]');
    var stockSwitch = document.querySelector('[data-bz5-instock]');
    var stockBox = document.querySelector('input[name="availability"][value="In stock"]');
    var boxes = document.querySelectorAll('.bz5-filters input[type=checkbox]');
    var pmin = document.querySelector('[data-bz5-pmin]'), pmax = document.querySelector('[data-bz5-pmax]');
    var price = null;
    var X = '<svg class="i" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg>';
    var banner = grid.querySelector('[data-bz5-banner]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bz5-pcard'));

    var applyStock = function () {
      var only = stockBox && stockBox.checked;
      cards.forEach(function (c) { c.hidden = only && c.getAttribute('data-avail') === '0'; });
    };
    var render = function () {
      tags.innerHTML = '';
      var n = 0;
      each(boxes, function (b) {
        if (!b.checked) return;
        n++;
        var li = document.createElement('li');
        li.innerHTML = '<button type="button" class="bz5-tag"></button>';
        var btn = li.firstChild;
        btn.textContent = b.getAttribute('data-label');
        btn.insertAdjacentHTML('beforeend', X);
        btn.setAttribute('aria-label', 'Remove filter: ' + b.getAttribute('data-label'));
        btn.addEventListener('click', function () { b.checked = false; sync(b); });
        tags.appendChild(li);
      });
      if (price) {
        n++;
        var li = document.createElement('li');
        li.innerHTML = '<button type="button" class="bz5-tag"></button>';
        li.firstChild.textContent = price;
        li.firstChild.insertAdjacentHTML('beforeend', X);
        li.firstChild.setAttribute('aria-label', 'Remove filter: ' + price);
        li.firstChild.addEventListener('click', function () { price = null; pmin.value = ''; pmax.value = ''; render(); });
        tags.appendChild(li);
      }
      tagsBox.hidden = n === 0;
      note.hidden = n === 0;
      fcount.textContent = n ? String(n) : '';
      each(document.querySelectorAll('.bz5-filters__clear'), function (c) { c.hidden = n === 0; });
      applyStock();
    };
    var sync = function (changed) {
      if (changed === stockBox && stockSwitch) stockSwitch.checked = stockBox.checked;
      render();
    };
    each(boxes, function (b) { b.addEventListener('change', function () { sync(b); }); });
    if (stockSwitch && stockBox) stockSwitch.addEventListener('change', function () { stockBox.checked = stockSwitch.checked; render(); });
    var apply = document.querySelector('[data-bz5-papply]');
    if (apply) apply.addEventListener('click', function () {
      var a = parseFloat(pmin.value), b = parseFloat(pmax.value);
      if (isNaN(a) && isNaN(b)) { price = null; } else { price = (isNaN(a) ? '$0' : '$' + a) + ' – ' + (isNaN(b) ? '$219' : '$' + b); }
      render();
    });
    each(document.querySelectorAll('[data-bz5-clear]'), function (c) {
      c.addEventListener('click', function () {
        each(boxes, function (b) { b.checked = false; });
        if (stockSwitch) stockSwitch.checked = false;
        price = null; if (pmin) { pmin.value = ''; pmax.value = ''; }
        render();
      });
    });

    var sortSel = document.querySelector('[data-bz5-sort]');
    if (sortSel) sortSel.addEventListener('change', function () {
      var v = sortSel.value, key;
      var num = function (a, k) { return parseFloat(a.getAttribute(k)); };
      if (v === 'price-ascending') key = function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); };
      else if (v === 'price-descending') key = function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); };
      else if (v === 'title-ascending') key = function (a, b) { return a.getAttribute('data-title') < b.getAttribute('data-title') ? -1 : 1; };
      else if (v === 'created-descending') key = function (a, b) { return a.getAttribute('data-created') < b.getAttribute('data-created') ? 1 : -1; };
      else key = function (a, b) { return num(a, 'data-pos') - num(b, 'data-pos'); };
      cards.sort(key);
      cards.forEach(function (c, i) { grid.appendChild(c); if (i === 7 && banner) grid.appendChild(banner); });
      note.hidden = false;
    });
  }

  /* ---------- buying guide: WAI-ARIA accordion (content stays in the page for search engines) ---------- */
  var topics = document.querySelectorAll('[data-bz5-topic]');
  each(topics, function (body) {
    var btn = document.querySelector('[aria-controls="' + body.id + '"]');
    if (!btn) return;
    var set = function (on) { btn.setAttribute('aria-expanded', on ? 'true' : 'false'); body.hidden = !on; };
    set(false);
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
  });
  var openFromHash = function () {
    var id = decodeURIComponent(location.hash.slice(1));
    var sec = id && document.getElementById(id);
    if (!sec) return;
    var body = sec.querySelector('[data-bz5-topic]');
    var btn = body && document.querySelector('[aria-controls="' + body.id + '"]');
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  };
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  /* ---------- cart: quantity, remove, add-ons, totals, sticky checkout bar ---------- */
  var cart = document.querySelector('[data-bz5-cart]');
  if (cart) {
    var lines = cart.querySelector('[data-bz5-lines]');
    var empty = document.querySelector('[data-bz5-empty]');
    var bar = document.querySelector('[data-bz5-cartbar]');
    var totals = function () {
      var items = 0, sub = 0, save = 0;
      each(lines.querySelectorAll('[data-bz5-line]'), function (l) {
        var q = Math.max(0, parseInt(l.querySelector('[data-bz5-qty]').value, 10) || 0);
        var p = parseFloat(l.getAttribute('data-price')), c = parseFloat(l.getAttribute('data-compare'));
        items += q; sub += p * q; if (c > p) save += (c - p) * q;
        l.querySelector('[data-bz5-ltotal]').textContent = money(p * q);
        var lc = l.querySelector('[data-bz5-lcompare]'); if (lc) lc.textContent = c > p ? money(c * q) : '';
      });
      each(document.querySelectorAll('[data-bz5-count]'), function (e) { e.textContent = '(' + items + (items === 1 ? ' item)' : ' items)'); });
      each(document.querySelectorAll('[data-bz5-items]'), function (e) { e.textContent = items + (items === 1 ? ' item' : ' items'); });
      each(document.querySelectorAll('[data-bz5-sub]'), function (e) { e.textContent = money(sub); });
      each(document.querySelectorAll('[data-bz5-total]'), function (e) { e.textContent = money(sub); });
      each(document.querySelectorAll('[data-bz5-save]'), function (e) { e.textContent = '−' + money(save); e.parentNode && (e.hidden = save === 0); });
      var saveRow = document.querySelectorAll('.bz5-sum .is-save'); each(saveRow, function (e) { e.hidden = save === 0; });
      // the header badge follows the cart (in the store the header also re-reads /cart.js after each change)
      each(document.querySelectorAll('[data-bzh-cart-count]'), function (e) { e.textContent = items; });
      each(document.querySelectorAll('[data-bzh-cart-label]'), function (e) { e.textContent = items + (items === 1 ? ' item' : ' items') + ' in cart'; });
      var hdr = document.querySelector('[data-bzh]'); if (hdr) hdr.classList.toggle('has-cart-items', items > 0);
      var none = !lines.querySelector('[data-bz5-line]');
      cart.hidden = none; if (empty) empty.hidden = !none; if (bar && none) bar.hidden = true;
    };
    var wire = function (l) {
      var q = l.querySelector('[data-bz5-qty]');
      var setQ = function (v) { v = Math.max(0, Math.min(99, v)); if (v === 0) { remove(l); return; } q.value = v; totals(); };
      l.querySelector('[data-bz5-dec]').addEventListener('click', function () { setQ((parseInt(q.value, 10) || 1) - 1); });
      l.querySelector('[data-bz5-inc]').addEventListener('click', function () { setQ((parseInt(q.value, 10) || 0) + 1); });
      q.addEventListener('change', function () { setQ(parseInt(q.value, 10) || 0); });
      l.querySelector('[data-bz5-remove]').addEventListener('click', function () { remove(l); });
    };
    var remove = function (l) {
      // removing a line blurs its focused quantity box, and that blur fires "change" -> setQ(0) -> remove() again
      if (l.__gone || !l.parentNode) return;
      l.__gone = true;
      var next = l.nextElementSibling || l.previousElementSibling;
      l.parentNode.removeChild(l);
      totals();
      var f = next && next.querySelector('a, button');
      if (f) f.focus(); else { var h = document.getElementById('bz5-empty-title'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); } }
    };
    each(lines.querySelectorAll('[data-bz5-line]'), wire);
    each(cart.querySelectorAll('[data-bz5-add]'), function (b) {
      b.addEventListener('click', function () {
        var d = JSON.parse(b.getAttribute('data-bz5-add'));
        var tpl = lines.querySelector('[data-bz5-line]');
        if (!tpl) return;
        var l = tpl.cloneNode(true);
        l.setAttribute('data-price', d.price); l.setAttribute('data-compare', 0);
        l.querySelector('.bz5-line__img img').src = d.img;
        each(l.querySelectorAll('a'), function (a) { a.href = d.url; });
        l.querySelector('h3 a').textContent = d.title;
        var v = l.querySelector('.bz5-line__var');
        if (v) { if (d.variant) v.innerHTML = d.variant; else v.parentNode.removeChild(v); }
        l.querySelector('.bz5-line__unit').innerHTML = '<b>' + money(d.price) + '</b><span> each</span>';
        each(l.querySelectorAll('[aria-label]'), function (e) { e.setAttribute('aria-label', e.getAttribute('aria-label').replace(/(of|Remove) .*$/, '$1 ' + d.title)); });
        l.querySelector('[data-bz5-qty]').value = 1;
        lines.appendChild(l); wire(l); totals();
        b.disabled = true; b.textContent = 'Added';
      });
    });
    totals();
    var checkout = cart.querySelector('[data-bz5-checkout]');
    if (bar && checkout && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var gone = !en[0].isIntersecting && en[0].boundingClientRect.top > 0;
        bar.hidden = !gone || cart.hidden;
      }).observe(checkout);
    }
  }
})();
